import { render, staticRenderFns } from "./editRate.vue?vue&type=template&id=0349df22&scoped=true&"
import script from "./editRate.vue?vue&type=script&lang=js&"
export * from "./editRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0349df22",
  null
  
)

export default component.exports